export { default } from './Dashboard.container'



// WEBPACK FOOTER //
// ./src/pages/Dashboard/index.js